import { useState, useEffect } from 'react';

export const useCustomerInfo = (userData = null) => {
  const [customerInfo, setCustomerInfo] = useState({
    name: "",
    phone: ""
  });

  // Actualizar customerInfo cuando cambie userData
  useEffect(() => {
    if (userData && typeof userData === 'object') {
      // Si hay información del usuario, usarla
      setCustomerInfo({
        name: userData.name || "",
        phone: userData.phone || "",
      });
    } else {
      // Si no hay información, dejar en blanco
      setCustomerInfo({
        name: "",
        phone: "",
      });
    }
  }, [userData]);

  const updateCustomerInfo = (field, value) => {
    setCustomerInfo(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const isFormValid = () => {
    return customerInfo.name.trim() && 
           customerInfo.phone.trim()
  };

  const resetForm = () => {
    setCustomerInfo({
      name: "",
      phone: ""
    });
  };

  return {
    customerInfo,
    updateCustomerInfo,
    isFormValid,
    resetForm,
  };
}; 